import { Link } from '@tanstack/react-router';
import { Plus } from 'lucide-react';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';

export function CreatePlacementAction({ adUnitAllowed }: { adUnitAllowed: boolean }) {
  if (!adUnitAllowed) {
    return (
      <Button asChild>
        <Link to="/supply/placements/create/$placementType" params={{ placementType: 'standard' }}>
          <Plus className="h-4 w-4" aria-hidden="true" />
          {dashboardT('placements.create')}
        </Link>
      </Button>
    );
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button>
          <Plus className="h-4 w-4" aria-hidden="true" />
          {dashboardT('placements.create')}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem asChild>
          <Link
            to="/supply/placements/create/$placementType"
            params={{ placementType: 'standard' }}
          >
            {dashboardT('placements.type.standard')}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/supply/placements/create/$placementType" params={{ placementType: 'ad-unit' }}>
            {dashboardT('placements.type.adUnit')}
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
